import { useTranslation } from 'react-i18next';

import { StatusBadge, StatusTone } from '../../../../components/design-system/admin';
import type { Temperature } from '../../../../modules/vendor/analytics/viz/lead-temperature';

const TONE: Record<Temperature, StatusTone> = { hot: 'danger', warm: 'warning', cold: 'neutral' };

/** Hot, warm or cold as a dot and a word — the only colour in a lead's row. */
export function TemperatureBadge({ temperature, className }: { temperature: Temperature; className?: string }) {
  const { t } = useTranslation();
  return (
    <StatusBadge tone={TONE[temperature]} className={className}>
      {t(`VIZ_ANALYTICS.TEMPERATURE.${temperature.toUpperCase()}`)}
    </StatusBadge>
  );
}
